import { NormalStartPresentation } from '../normal/NormalStartPresentation';

export class FSStartPresentation extends NormalStartPresentation {

    constructor() { super(); this.isNormalStart = false; }
    
    // preStart(): void {
    //     debugger;
    //     super.preStart();

    //     // this.layoutChanging = false;
    //     // RoadRage.reelManager.applyMask(true);

    //     // this.willChangeSize = RoadRageEngineManager.wantsToSwitch;
    //     // debugger;
    //     // if(!this.willChangeSize)
    //     //     WaysCounter.instance.setValue(undefined, MathHelper.WaysCount(RoadRageEngineManager.AllReels.length, RoadRageEngineManager.preferedLayoutSize), 0.25);
    // }
}